/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { LineSearchResultVO } from '../model';
// @ts-ignore
import * as Objs from './index'
// @ts-ignore
import { DataResponseVO, DataRequestVO, ExportRequestVO } from '@mc/data-filter-react';

/**
 * XrnControllerApi - axios parameter creator
 * @export
 */
export const XrnControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} uliceId 
         * @param {string} [cisloOd] 
         * @param {string} [cisloDo] 
         * @param {boolean} [objizdka] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefinicniCaraUliceExt: async (uliceId: number, cisloOd?: string, cisloDo?: string, objizdka?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'uliceId' is not null or undefined
            assertParamExists('getDefinicniCaraUliceExt', 'uliceId', uliceId)
            const localVarPath = `/api/xrn/ulice/{uliceId}/cara-ext`
                .replace(`{${"uliceId"}}`, encodeURIComponent(String(uliceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cisloOd !== undefined) {
                localVarQueryParameter['cisloOd'] = cisloOd;
            }

            if (cisloDo !== undefined) {
                localVarQueryParameter['cisloDo'] = cisloDo;
            }

            if (objizdka !== undefined) {
                localVarQueryParameter['objizdka'] = objizdka;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí definiční čáru ulice v GeoJSON formátu
         * @param {number} uliceId 
         * @param {string} [cisloOd] 
         * @param {string} [cisloDo] 
         * @param {boolean} [objizdka] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefinicniCaraUliceExtGeojson: async (uliceId: number, cisloOd?: string, cisloDo?: string, objizdka?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'uliceId' is not null or undefined
            assertParamExists('getDefinicniCaraUliceExtGeojson', 'uliceId', uliceId)
            const localVarPath = `/api/xrn/ulice/{uliceId}/cara-ext-geojson`
                .replace(`{${"uliceId"}}`, encodeURIComponent(String(uliceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cisloOd !== undefined) {
                localVarQueryParameter['cisloOd'] = cisloOd;
            }

            if (cisloDo !== undefined) {
                localVarQueryParameter['cisloDo'] = cisloDo;
            }

            if (objizdka !== undefined) {
                localVarQueryParameter['objizdka'] = objizdka;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí definiční čáru ulice v GeoJSON formátu
         * @param {number} uliceId 
         * @param {string} [cisloOd] 
         * @param {string} [cisloDo] 
         * @param {boolean} [objizdka] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefinicniCaraUliceExtGeojson_1: async (uliceId: number, cisloOd?: string, cisloDo?: string, objizdka?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'uliceId' is not null or undefined
            assertParamExists('getDefinicniCaraUliceExtGeojson_1', 'uliceId', uliceId)
            const localVarPath = `/xrn/ulice/{uliceId}/cara-ext-geojson`
                .replace(`{${"uliceId"}}`, encodeURIComponent(String(uliceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cisloOd !== undefined) {
                localVarQueryParameter['cisloOd'] = cisloOd;
            }

            if (cisloDo !== undefined) {
                localVarQueryParameter['cisloDo'] = cisloDo;
            }

            if (objizdka !== undefined) {
                localVarQueryParameter['objizdka'] = objizdka;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} uliceId 
         * @param {string} [cisloOd] 
         * @param {string} [cisloDo] 
         * @param {boolean} [objizdka] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefinicniCaraUliceExt_2: async (uliceId: number, cisloOd?: string, cisloDo?: string, objizdka?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'uliceId' is not null or undefined
            assertParamExists('getDefinicniCaraUliceExt_2', 'uliceId', uliceId)
            const localVarPath = `/xrn/ulice/{uliceId}/cara-ext`
                .replace(`{${"uliceId"}}`, encodeURIComponent(String(uliceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cisloOd !== undefined) {
                localVarQueryParameter['cisloOd'] = cisloOd;
            }

            if (cisloDo !== undefined) {
                localVarQueryParameter['cisloDo'] = cisloDo;
            }

            if (objizdka !== undefined) {
                localVarQueryParameter['objizdka'] = objizdka;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * XrnControllerApi - functional programming interface
 * @export
 */
export const XrnControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = XrnControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} uliceId 
         * @param {string} [cisloOd] 
         * @param {string} [cisloDo] 
         * @param {boolean} [objizdka] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefinicniCaraUliceExt(uliceId: number, cisloOd?: string, cisloDo?: string, objizdka?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LineSearchResultVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefinicniCaraUliceExt(uliceId, cisloOd, cisloDo, objizdka, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Vrátí definiční čáru ulice v GeoJSON formátu
         * @param {number} uliceId 
         * @param {string} [cisloOd] 
         * @param {string} [cisloDo] 
         * @param {boolean} [objizdka] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefinicniCaraUliceExtGeojson(uliceId: number, cisloOd?: string, cisloDo?: string, objizdka?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LineSearchResultVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefinicniCaraUliceExtGeojson(uliceId, cisloOd, cisloDo, objizdka, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Vrátí definiční čáru ulice v GeoJSON formátu
         * @param {number} uliceId 
         * @param {string} [cisloOd] 
         * @param {string} [cisloDo] 
         * @param {boolean} [objizdka] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefinicniCaraUliceExtGeojson_1(uliceId: number, cisloOd?: string, cisloDo?: string, objizdka?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LineSearchResultVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefinicniCaraUliceExtGeojson_1(uliceId, cisloOd, cisloDo, objizdka, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} uliceId 
         * @param {string} [cisloOd] 
         * @param {string} [cisloDo] 
         * @param {boolean} [objizdka] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefinicniCaraUliceExt_2(uliceId: number, cisloOd?: string, cisloDo?: string, objizdka?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LineSearchResultVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefinicniCaraUliceExt_2(uliceId, cisloOd, cisloDo, objizdka, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * XrnControllerApi - factory interface
 * @export
 */
export const XrnControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = XrnControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} uliceId 
         * @param {string} [cisloOd] 
         * @param {string} [cisloDo] 
         * @param {boolean} [objizdka] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefinicniCaraUliceExt(uliceId: number, cisloOd?: string, cisloDo?: string, objizdka?: boolean, options?: any): AxiosPromise<LineSearchResultVO> {
            return localVarFp.getDefinicniCaraUliceExt(uliceId, cisloOd, cisloDo, objizdka, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí definiční čáru ulice v GeoJSON formátu
         * @param {number} uliceId 
         * @param {string} [cisloOd] 
         * @param {string} [cisloDo] 
         * @param {boolean} [objizdka] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefinicniCaraUliceExtGeojson(uliceId: number, cisloOd?: string, cisloDo?: string, objizdka?: boolean, options?: any): AxiosPromise<LineSearchResultVO> {
            return localVarFp.getDefinicniCaraUliceExtGeojson(uliceId, cisloOd, cisloDo, objizdka, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí definiční čáru ulice v GeoJSON formátu
         * @param {number} uliceId 
         * @param {string} [cisloOd] 
         * @param {string} [cisloDo] 
         * @param {boolean} [objizdka] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefinicniCaraUliceExtGeojson_1(uliceId: number, cisloOd?: string, cisloDo?: string, objizdka?: boolean, options?: any): AxiosPromise<LineSearchResultVO> {
            return localVarFp.getDefinicniCaraUliceExtGeojson_1(uliceId, cisloOd, cisloDo, objizdka, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} uliceId 
         * @param {string} [cisloOd] 
         * @param {string} [cisloDo] 
         * @param {boolean} [objizdka] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefinicniCaraUliceExt_2(uliceId: number, cisloOd?: string, cisloDo?: string, objizdka?: boolean, options?: any): AxiosPromise<LineSearchResultVO> {
            return localVarFp.getDefinicniCaraUliceExt_2(uliceId, cisloOd, cisloDo, objizdka, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * XrnControllerApi - interface
 * @export
 * @interface XrnControllerApi
 */
export interface XrnControllerApiInterface {
    /**
     * 
     * @param {number} uliceId 
     * @param {string} [cisloOd] 
     * @param {string} [cisloDo] 
     * @param {boolean} [objizdka] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XrnControllerApiInterface
     */
    getDefinicniCaraUliceExt(uliceId: number, cisloOd?: string, cisloDo?: string, objizdka?: boolean, options?: any): AxiosPromise<LineSearchResultVO>;

    /**
     * Vrátí definiční čáru ulice v GeoJSON formátu
     * @param {number} uliceId 
     * @param {string} [cisloOd] 
     * @param {string} [cisloDo] 
     * @param {boolean} [objizdka] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XrnControllerApiInterface
     */
    getDefinicniCaraUliceExtGeojson(uliceId: number, cisloOd?: string, cisloDo?: string, objizdka?: boolean, options?: any): AxiosPromise<LineSearchResultVO>;

    /**
     * Vrátí definiční čáru ulice v GeoJSON formátu
     * @param {number} uliceId 
     * @param {string} [cisloOd] 
     * @param {string} [cisloDo] 
     * @param {boolean} [objizdka] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XrnControllerApiInterface
     */
    getDefinicniCaraUliceExtGeojson_1(uliceId: number, cisloOd?: string, cisloDo?: string, objizdka?: boolean, options?: any): AxiosPromise<LineSearchResultVO>;

    /**
     * 
     * @param {number} uliceId 
     * @param {string} [cisloOd] 
     * @param {string} [cisloDo] 
     * @param {boolean} [objizdka] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XrnControllerApiInterface
     */
    getDefinicniCaraUliceExt_2(uliceId: number, cisloOd?: string, cisloDo?: string, objizdka?: boolean, options?: any): AxiosPromise<LineSearchResultVO>;

}

/**
 * XrnControllerApi - object-oriented interface
 * @export
 * @class XrnControllerApi
 * @extends {BaseAPI}
 */
export class XrnControllerApi extends BaseAPI implements XrnControllerApiInterface {
    /**
     * 
     * @param {number} uliceId 
     * @param {string} [cisloOd] 
     * @param {string} [cisloDo] 
     * @param {boolean} [objizdka] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XrnControllerApi
     */
    public getDefinicniCaraUliceExt(uliceId: number, cisloOd?: string, cisloDo?: string, objizdka?: boolean, options?: any) {
        return XrnControllerApiFp(this.configuration).getDefinicniCaraUliceExt(uliceId, cisloOd, cisloDo, objizdka, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí definiční čáru ulice v GeoJSON formátu
     * @param {number} uliceId 
     * @param {string} [cisloOd] 
     * @param {string} [cisloDo] 
     * @param {boolean} [objizdka] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XrnControllerApi
     */
    public getDefinicniCaraUliceExtGeojson(uliceId: number, cisloOd?: string, cisloDo?: string, objizdka?: boolean, options?: any) {
        return XrnControllerApiFp(this.configuration).getDefinicniCaraUliceExtGeojson(uliceId, cisloOd, cisloDo, objizdka, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí definiční čáru ulice v GeoJSON formátu
     * @param {number} uliceId 
     * @param {string} [cisloOd] 
     * @param {string} [cisloDo] 
     * @param {boolean} [objizdka] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XrnControllerApi
     */
    public getDefinicniCaraUliceExtGeojson_1(uliceId: number, cisloOd?: string, cisloDo?: string, objizdka?: boolean, options?: any) {
        return XrnControllerApiFp(this.configuration).getDefinicniCaraUliceExtGeojson_1(uliceId, cisloOd, cisloDo, objizdka, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} uliceId 
     * @param {string} [cisloOd] 
     * @param {string} [cisloDo] 
     * @param {boolean} [objizdka] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XrnControllerApi
     */
    public getDefinicniCaraUliceExt_2(uliceId: number, cisloOd?: string, cisloDo?: string, objizdka?: boolean, options?: any) {
        return XrnControllerApiFp(this.configuration).getDefinicniCaraUliceExt_2(uliceId, cisloOd, cisloDo, objizdka, options).then((request) => request(this.axios, this.basePath));
    }
}
